<template>
  <div>
    <div class="swiper-container">
      <div class="swiper-wrapper">
        <div class="swiper-slide" v-for="(slide, index) in slides" :key="index">
          <img class="slide" :src="slide.src" :alt="slide.title">
        </div>
      </div>
    </div>
    <ul class="swiper-custom-pagination">
      <li
        v-for="(slide, index) in slides"
        :key="index"
        :class="{active: activeIndex - 1 === index}"
        @click="swiper.slideTo(index + 1)"
      ><img :src="slide.src"></li>
    </ul>

    <h2>
      <div class="bg"></div>
      <img src="images/main-banner.png" alt="周易金牌风水师">
      <span class="hide-text">周易金牌风水师</span>
    </h2>
  </div>
</template>

<script>
import Swiper from 'swiper'
export default {
  name: 'banner',
  data () {
    return {
      slides: [{
        title: '叶老师照片',
        src: 'images/slides/slide-1.png'
      }, {
        title: '2012首届全球周易大会荣誉证书',
        src: 'images/slides/slide-4.jpg'
      }, {
        title: '世界易学领袖协会荣誉证书',
        src: 'images/slides/slide-5.jpg'
      }, {
        title: '美国东方大学客座教授证书',
        src: 'images/slides/slide-7.jpg'
      }, {
        title: '美国东方大学客座教授授予证明',
        src: 'images/slides/slide-8.jpg'
      }],
      activeIndex: 1,
      swiper: null
    }
  },
  mounted () {
    this.swiper = new Swiper('.swiper-container', {
      loop: true,
      speed: 800,
      autoplay: {
        delay: 5000
      },
      autoHeight: true,
      on: {
        slideChange: () => {
          if (!this.swiper) return
          this.activeIndex = this.swiper.activeIndex
        }
      }
    })
  }
}
</script>

<style scoped lang="scss">
.hide-text{
  position: absolute;
  top: 0;
  opacity: 0;
  pointer-events: none;
}
  img{
    width: 100%;
    height: auto;
    display: block;
  }
  h2{
    position: relative;
    font-weight: normal;
    text-align: center;
    color: $red;
    font-size: 4.2rem;
    white-space: nowrap;
    line-height: 2;
    span{
      font-size: 1.3em;
    }
    .bg{
      background: url("../assets/images/page-bg.png") no-repeat center;
      background-size: 300px auto;
    }
  }
  .swiper-container,
  .swiper-custom-pagination {
    width: calc(100% + 30px);
    margin: 0 -15px;
  }
  .swiper-custom-pagination{
    padding: 5px;
    display: flex;
    justify-content: center;
    height: 90px;
    li{
      width: auto;
      height: 100%;
      display: flex;
      align-items: center;
      justify-content: center;
      overflow: hidden;
      padding: 3px;
      margin: 0 3px;
      background: #e2e2e2;
      box-shadow: rgba(0,0,0,0) 0 0 3px;
      transition: .3s;
      img{
        width: auto;
        height: 100%;
      }
      &.active {
        background: rgb(241, 207, 102);
        box-shadow: rgba(0,0,0,.3) 0 2px 3px;
      }
    }
  }
  .mobile{
    h2{
      margin: 0 -15px;
      padding: 0;
      font-size: 9vw;
      background: rgba(230,218,180,1);
      background: -moz-linear-gradient(45deg, rgba(230,218,180,1) 0%, rgba(240,235,218,1) 100%);
      background: -webkit-gradient(left bottom, right top, color-stop(0%, rgba(230,218,180,1)), color-stop(100%, rgba(240,235,218,1)));
      background: -webkit-linear-gradient(45deg, rgba(230,218,180,1) 0%, rgba(240,235,218,1) 100%);
      background: -o-linear-gradient(45deg, rgba(230,218,180,1) 0%, rgba(240,235,218,1) 100%);
      background: -ms-linear-gradient(45deg, rgba(230,218,180,1) 0%, rgba(240,235,218,1) 100%);
      background: linear-gradient(45deg, rgba(230,218,180,1) 0%, rgba(240,235,218,1) 100%);
      filter: progid:DXImageTransform.Microsoft.gradient( startColorstr='#e6dab4', endColorstr='#f0ebda', GradientType=1 );
      text-shadow: rgba(255, 255, 255, 0.64) 0 1px 0;
      .bg{
        background-position: right center;
        background-size: auto 150%;
      }
    }
    .swiper-custom-pagination{
      height: 50px;
    }
  }
</style>
